<script setup>
import {onClickHashLink} from "../../../Helpers/helper";

const list = [
    'Готовые редакции',
    'Хоумбрю',
    'Расы, классы, способности, навыки',
    'Детальная настройка: от&nbsp;веса предметов до&nbsp;наличия модифов',
    'Мастерские заметки',
    'Доступ игроков в&nbsp;миры по&nbsp;инвайтам',
    'Переключение между редакциями и&nbsp;мирами',
];
</script>

<template>
    <section id="master" class="group section-screen mt-12 md:mt-20 xl:mt-44 pb-14 lg:pb-28 relative">
        <div class="relative max-w-full w-[1536px] mx-auto px-6 mt-[4.2rem] flex flex-col items-end">
            <div class="w-full relative px-6 lg:absolute lg:px-0 lg:top-0 lg:left-0 lg:w-1/2 2xl:w-3/5">
                <div class="w-[110%] md:w-[80%] -translate-x-[22%] md:translate-x-0 lg:-translate-x-[16%] top-0 left-[1.5%] lg:max-w-[100%] lg:w-[794px]">
                    <svg width="100%" height="100%" viewBox="0 0 794 794"
                         fill="none"
                         xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                         class="w-full opacity-0 transition-all duration-500 group-[.visited]:opacity-100"
                    >
                        <path d="M381.693 3.34051C391.494 -0.719247 402.506 -0.719252 412.307 3.34051L664.535 107.817C674.336 111.877 682.123 119.663 686.183 129.465L790.659 381.693C794.719 391.494 794.719 402.506 790.659 412.307L686.183 664.535C682.123 674.336 674.336 682.123 664.535 686.183L412.307 790.659C402.506 794.719 391.494 794.719 381.693 790.659L129.465 686.183C119.664 682.123 111.877 674.336 107.817 664.535L3.34051 412.307C-0.719247 402.506 -0.719252 391.494 3.34051 381.693L107.817 129.465C111.877 119.664 119.663 111.877 129.465 107.817L381.693 3.34051Z"
                              fill="url(#master-polygon-pattern)"/>
                        <defs>
                            <pattern id="master-polygon-pattern" width="100%" height="100%">
                                <image id="master-polygon-image" width="100%" xlink:href="/images/polygon-3.png" class="transition-transform duration-[10s] origin-center scale-110 group-[.visited]:scale-100"/>
                            </pattern>
                        </defs>
                    </svg>
                </div>
                <div class="screen-dice-wrapper absolute h-[88%] right-6 max-w-[40%] md:max-w-[30%] top-2/3 -translate-y-1/2 lg:right-1/2 lg:translate-x-1/3 lg:top-1/2 2xl:top-1/3 lg:-translate-y-[3%] lg:max-w-[43%] duration-1000 opacity-0 transition-opacity group-[.visited]:opacity-100">
                    <img src="/images/phone-4.png" alt="" class="max-w-full max-h-full mx-auto transition-transform duration-1000 -translate-x-[20%] group-[.visited]:translate-x-0 dark:hidden">
                    <img src="/images/phone-4-dark.png" alt="" class="max-w-full max-h-full mx-auto transition-transform duration-1000 -translate-x-[20%] group-[.visited]:translate-x-0 hidden dark:block">

                    <div class="screen-dice d4"></div>
                    <div class="screen-dice d6"></div>
                    <div class="screen-dice d8"></div>
                    <div class="screen-dice d10"></div>
                    <div class="screen-dice d20"></div>
                </div>
            </div>
            <div class="w-full lg:w-1/2">
                <div class="pt-16 lg:pt-[2.8rem] xl:pt-[4.5rem] lg:pr-[17%]">
                    <div class="text-xs md:text-md lg:text-lg my-1 md:my-3 text-purple">&mdash; мастеру</div>
                    <div class="text-3xl -tracking-[0.04em] lg:text-5xl xl:text-6xl font-extrabold leading-none text-black dark:text-white">Ширма</div>
                    <div class="mt-5 text-sm md:mt-7 md:text-xl xl:text-2xl !leading-normal">
                        Классика или хоумбрю?<br>
                        Quenta заменит данжбуки с&nbsp;правилами
                        и&nbsp;лором миров. Собирай игроков и&nbsp;веди в&nbsp;самое эпическое приключение
                        в&nbsp;их&nbsp;жизни
                    </div>
                </div>
            </div>
            <div class="w-full lg:w-1/2 mt-7 lg:mt-12 lg:relative">
                <div class="text-xl md:text-3xl lg:text-[2.5rem] font-bold leading-none tracking-tighter text-black dark:text-white">Уже сейчас:</div>
                <ul class="text-sm md:text-md lg:text-[1rem] mt-3 md:mt-6 list-disc leading-[2em] text-purple pl-3 md:pl-6">
                    <li v-for="item in list" v-html="item"></li>
                </ul>
                <a href="/#subscribe" class="btn mt-8 md:mt-16 text-purple" @click="onClickHashLink">
                    <span class="btn-text">Это нам надо</span>
                    <span class="btn-hover-wrapper">
                        <span class="btn-hover">
                            <span>Это нам надо</span>
                        </span>
                    </span>
                </a>
            </div>
        </div>
    </section>
</template>

<style lang="scss">
    #master .screen-dice {
        &.d4 {
            @apply bottom-[105%] left-[50%] md:bottom-[75%] md:left-[75%];
        }

        &.d6 {
            @apply hidden;
        }

        &.d8 {
            @apply hidden;
        }

        &.d10 {
            @apply -bottom-[20%] right-[80%] md:bottom-[20%] md:right-[80%];
        }

        &.d20 {
            @apply top-[45%] -right-[45%] md:top-[80%] md:right-[50%];
        }
    }
</style>
